import { connect } from "react-redux";
import React, { Component } from "react";

import { closeModalPurchaseError } from "../../../actions/purchaseActions";

export class ModalPurchaseError extends Component {
  render() {
    if (!this.props.isModalPurchaseErrorActive) return <div />;

    return (
      <div className="comp_modalpagamento">
        <div className="modalcontents">
          <div className="contents">
            <div className="modaltop">
              <div className="title">Pedido duplicado:</div>

              <div
                onClick={this.props.closeModalPurchaseError}
                className="close-btn"
              >
                {" "}
                &times;{" "}
              </div>
            </div>

            <div className="modalmiddle">
              <p>
                <img
                  src="/assets/images/pagamento/alert.svg"
                  alt="erro"
                />
              </p>
              <p>
                <strong>
                  Já existe um pedido aberto com os mesmos dados de compra
                  inseridos.
                </strong>
              </p>
              <p>
                Por favor, verifique seu e-mail (inclusive a caixa de spam e
                lixo eletrônico) para acompanhar seus pedidos. Em caso de dúvida
                entre em contato conosco
              </p>
              <p>
                <h2>31 4003-8442</h2>
              </p>
            </div>

            <div className="modalbotton">
              <strong>Importante:</strong> Ao finalizar o seu pedido você
              receberá um e-mail com a solicitação da compra e instruções para
              pagamento de acordo com o banco escolhido.
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    isModalPurchaseErrorActive: state.purchase.isModalPurchaseErrorActive
  }),
  {
    closeModalPurchaseError
  }
)(ModalPurchaseError);



// WEBPACK FOOTER //
// ./src/components/purchase/modal_purchase_error/ModalPurchaseError.jsx